import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Edit,
  SimpleForm,
  Toolbar,
  SaveButton,
  TextInput,
  FileInput,
  ImageField,
  required,
  useUpdate,
  useNotify,
  useRedirect
} from 'react-admin';

import { uploadImage } from '../../../config/services/strapi/strapi';

function ExponentePodcastEdit(props: any) {
  const [imagesChanged, setImagesChanged] = useState({
    imagen: false,
  });

  const [update] = useUpdate();
  const redirect = useRedirect();
  const notify = useNotify();

  const { id } = useParams();

  const handleSubmit = async (data: any) => {
    const token = localStorage.getItem('strapi_jwt');
    if (!token) {
      notify('No se encontró el token de autenticación', { type: 'error' });
      return;
    }

    try {
      const payload = {
        ...data,
      };

      if (imagesChanged.imagen && data.imagen?.rawFile) {
        payload.imagen = await uploadImage(data.imagen.rawFile, token);

        delete payload.imagen.documentId; // Asegurarse de no enviar el ID del documento
      }

      delete payload.id; // Asegurarse de no enviar el ID en el payload
      delete payload.createdAt;
      delete payload.updatedAt;
      delete payload.publishedAt;
      delete payload.documentId;
      delete payload.ref;

      update(
        'exponentes-podcasts',
        { data: payload, id: id },
        {
          onSuccess: () => {
            notify('Elemento actualizado');
            redirect('list', 'exponentes-podcasts');
          },
          onError: (error: any) => {
            notify(`Error: ${error.message}`, { type: 'error' });
          },
        }
      );
    } catch (error) {
      console.error('Error al actualizar el exponente de podcast:', error);
      notify('Error al actualizar el exponente de podcast', { type: 'error' });
    }
  };

  useEffect(() => {
    document.title = 'Editar Exponente de Podcast';
  }, []);

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="id" disabled />
        <TextInput source="nombre" validate={[required()]} />
        <TextInput source="empresa" validate={[required()]} />
        <TextInput source="cargo" validate={[required()]} />
        <FileInput
          source='imagen'
          label='Imagen'
          validate={[required()]}
          onChange={() => setImagesChanged(prev => ({ ...prev, imagen: true }))}
        >
          <>
            {imagesChanged.imagen && <ImageField source="src" />}
            {!imagesChanged.imagen && <ImageField source="url" />}
          </>
        </FileInput>
      </SimpleForm>
    </Edit>
  )
}

export default ExponentePodcastEdit;